import store from "../store";
import routeNames from "./route-names";
import router from "../router";

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
export default {
  authGuard(to, from, next) {
    if (store.getters.authStatus === false) {
      const token = to.query.token;
      if (token) {
        store.dispatch("logIn", { router: router, token });
        next({
          path: to.path,
          params: to.params,
          query: Object.fromEntries(
            Object.entries(to.query).filter(([key]) => key !== "token")
          ),
          replace: true,
        });
      } else {
        next({
          name: routeNames.LOGIN,
          params: to.params,
        });
      }
    } else {
      next();
    }
  },
  loginGuard(to, from, next) {
    if (store.getters.authStatus === true) {
      next({
        name: routeNames.WALLET,
        params: to.params,
      });
    } else {
      next();
    }
  },
  iframeGuard(to, from, next) {
    if (!inIframe()) {
      next({
        name: routeNames.WALLET,
        params: to.params,
      });
    } else {
      next();
    }
  },
  paymentGuard(to, from, next) {
    if (store.getters.authStatus === false) {
      next({
        name: routeNames.LOGIN,
        params: to.params,
      });
    } else {
      if (store.getters.customization != null) {
        const context = this;
        store.dispatch("getPaymentData", context).then((paymentData) => {
          if (paymentData != null) {
            if (
              (to.name === routeNames.PAYMENT_METHOD &&
                ((paymentData.paylands && paymentData.paylands.enabled) ||
                  (paymentData.mercadopago &&
                    paymentData.mercadopago.enabled))) ||
              (paymentData.mit && paymentData.mit.enabled)
            ) {
              next();
            } else if (
              ((to.name === routeNames.PAYLANDS ||
                to.name === routeNames.TOPUP) &&
                paymentData.paylands &&
                paymentData.paylands.enabled) ||
              (paymentData.mit && paymentData.mit.enabled)
            ) {
              next();
            } else if (
              (to.name === routeNames.MERCADOPAGO ||
                to.name === routeNames.TOPUP) &&
              paymentData.mercadopago &&
              paymentData.mercadopago.enabled
            ) {
              next();
            } else {
              next({
                name: routeNames.WALLET,
                params: to.params,
              });
            }
          }
        });
      } else {
        next({
          name: routeNames.WALLET,
          params: to.params,
        });
      }
    }
  },
  urlAccessGuard(to, from, next) {
    if (store.getters.authStatus === false) {
      next({
        name: routeNames.LOGIN,
        params: to.params,
      });
    } else {
      store.getters.customization != null
        ? next()
        : next({ name: routeNames.WALLET, params: to.params });
    }
  },
};
